import React, { useState } from "react";

import { apiEndpoints } from "../../config";
import PostSingle from "../../partials/posts/postSingle";

export default function VideoSingle(props) {
  const [post, setPost] = useState(null);

  return (
    <PostSingle
      preview={props.preview}
      apiEndpoint={apiEndpoints.news}
      entityFavoritesContentType={"news"}
      previewReturnRoute={"/news-creator"}
      returnRoute={"/news"}
      backBtnText={"News Library"}
      screenClassName={"news"}
      v2Bundle={"news"}
      logCustomEventType={"News"}
      entityType={"news"}
      featuredImageEnabled={true}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
    >
    </PostSingle>
  );
}
